
import React, { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import { getShowcases } from "../../redux/actions/showcase";
import axios from "axios";
import Swal from "sweetalert2";
import { serverUrl } from "../Helpers/Config";
import { tokenAuthorize } from "../Helpers/Common";
import { ButtonCommonTopNew } from '../../pages/Theme';
import { ValuesNormalCount, ValuesActiveCount } from "../../pages/Theme";
// This version (16.6.0) is compatible with React 16.8.5+ and React 17
const initialItems = [
  "Entertainment",
  "Private Time",
  "Rest",
  "Meal",
  "Exercise",
  "Work",
  "Home Projects",
  "Family"
];

const ModalDraggable = ({ showcase, selectedShowcase, onClose }) => {
  const [items, setItems] = useState(showcase);
  const dispatch = useDispatch()

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const newItems = Array.from(items);
    const [reorderedItem] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, reorderedItem);

    setItems(newItems);
  };

  const handleSave = () => {
    let data = [];
    let arr = {};
    items.map((t, index) => (
      arr = {
        "reflection_id": t.id,
        "order": items.length - index
      },
      data.push(arr)
    ))
    axios.put(serverUrl.ShowCaseReorder + "/" + selectedShowcase?.id, data)
      .then((resp) => {
        if (resp.status === 200) {
          Swal.fire({
            title: "Success",
            text: "Post has been Updated",
            icon: "success",
          })
          dispatch(getShowcases());
          onClose();
        } else {
          Swal.fire({
            title: "Error",
            text: "Post not Updated",
            icon: "error",
          })
        }
      })
      .catch((error) => {
        tokenAuthorize(error?.response?.status);
        Swal.fire({
          title: "Error",
          text: "Post not Updated",
          icon: "error",
        })
      });
  }
  return (
    <div className="pt-2 rounded-lg">
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <Droppable droppableId="items">
          {(provided, snapshot) => (
            <ul
              {...provided.droppableProps}
              ref={provided.innerRef}
              className={`space-y-2 transition-colors ${snapshot.isDraggingOver ? '' : 'cardBackgroundColor'
                }`}
            >
              {items.map((item, index) => (
                <Draggable key={item.id} draggableId={item.title} index={index}>
                  {(provided, snapshot) => (
                    <li
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className={`
                          p-4 rounded-md cursor-grab active:cursor-grabbing
                          flex items-center text-sm font-medium
                          ${snapshot.isDragging
                          ? 'blueBackGroundColorDraggable border shadow-lg scale-105 rotate-2'
                          : 'grayBackGroundColorNonDraggable border shadow-sm transition-colors duration-150'
                        }
                        `}
                    >
                      <span className={`${snapshot.isDragging ? "text-white" : "blackColor"} mr-3 text-lg`}>⋮⋮</span>
                      {/* <ValuesNormalCount className='px-2 mr-3 text-xs rounded-full h-5 w-5 flex items-center justify-center'>{index + 1}</ValuesNormalCount> */}
                      <span className={`text-sm mt-0.5 ${snapshot.isDragging ? "text-white" : "blackColor"} `}>{item.title}</span>
                    </li>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </ul>
          )}
        </Droppable>
      </DragDropContext>

      {/* Current order display */}
      <div className="pt-4 flex items-center justify-center">
        <ButtonCommonTopNew className="px-5 border p-2  text-sm rounded-lg cursor-pointer" onClick={handleSave}>
          Update
        </ButtonCommonTopNew>
      </div>
    </div>
  );
}

export default ModalDraggable;
